import { awsApiAdapter } from 'src/utils/awsApiAdapter';
import { gql } from '@apollo/client';
import { UpdateUserInput, UpdateUserMutation } from 'src/API';
import * as mutations from 'src/graphql/mutations';
import { useError } from 'src/contexts/ErrorContext';

export const useCybozuUser = () => {
  const { reportError } = useError();
  const updateUser = async (input: UpdateUserInput) => {
    console.log('start updateUser', input);
    try {
      await awsApiAdapter.graphqlMutation<UpdateUserMutation>({
        mutation: gql(mutations.updateUser as any) as any,
        variables: {
          input,
        },
      });
    } catch (error) {
      reportError(error);
    }
  };
  const recordCybozuCredentials = async (
    userId: string,
    accessToken: string,
    refreshToken: string
  ) => {
    const input: UpdateUserInput = {
      id: userId,
      cybozuAccountCredentials: {
        accessToken,
        refreshToken,
      },
    };
    await updateUser(input);
  };
  // garoon連携解除
  const cancelGaroonIntegration = async (userId: string) => {
    const input: UpdateUserInput = {
      id: userId,
      cybozuAccountCredentials: null,
    };

    await updateUser(input);
  };

  return {
    cancelGaroonIntegration,
    recordCybozuCredentials,
  };
};
